<template>
  <!-- Assembled from the shared v2026 blocks; this file owns only the system-card
       wrappers. Two rules govern it, both in the script: `disabledTabs` (tabs 3+4 render
       but never activate here) and `showBlocks` (six Tab-1 blocks hidden, not deleted). -->
  <div class="v2026-applicant-panel">

    <PanelCollapseBarV2026 ariaLabel="ย่อแผงข้อมูลผู้สมัคร"
                           @toggleCollapse="$emit('toggleCollapse')" />

    <PanelTabBarV2026 :activeTab="activeTab" :disabledTabs="disabledTabs"
                      :labels="tabLabels" @setTab="setTab" />

    <PanelSubTabBarV2026 v-if="showSubTabBar"
                         :items="visibleSubTabs"
                         :activeKey="activeSubKey"
                         @select="goToSubTab" />

    <div class="v2026-ap-scroll" ref="subTabScroll">

    <div class="v2026-ap-tabpane" v-if="activeTab === 1">

      <PanelHeaderV2026 :type="2"
                        :statusIcons="headerStatusIcons"
                        :avatarUrl="avatarUrl"
                        :channelBadge="channelBadge"
                        :displayName="headerName"
                        :roleLabel="roleLabel"
                        :subLink="regionLabel"
                        addLabel="เพิ่มชื่อ"
                        :canEdit="hasConv"
                        :convCustomer="conv"
                        :conversationId="conversationId"
                        :customerType="selectedConversation && selectedConversation.customer_type"
                        :professional="conv && conv.beneat_professional"
                        :beneatUserId="conv && conv.beneat_user_id"
                        :beneatUserHref="headerUserHref"
                        @notify="showToast($event.variant, $event.title, $event.message)" />

      <ImportantMessageV2026 v-if="conv" :customer="conv" :conversationId="conversationId" />

      <!-- `|| hasConv`: a brand-new applicant has no ID, phone or email yet, and this card is the
           only place to enter the phone that /search-user matches the application on. -->
      <UserInfoCardV2026 v-if="hasContactRow || hasConv"
                         :type="pro ? 1 : 2"
                         :dynamicRows="true"
                         :idValue="entityIdValue"
                         :phone="phone"
                         :email="email"
                         :hasEmail="true"
                         :idHref="entityIdHref"
                         :canEdit="hasConv"
                         :convCustomer="conv"
                         :conversationId="conversationId" />

      <TagsSectionV2026 :type="1" :selectedConversation="selectedConversation"
                        :tags="tags" :admin="admin" />

      <div class="v2026-ap-system" v-if="showBlocks.systemProfessional && pro"><!-- HIDDEN, see showBlocks -->
        <span class="v2026-ap-section-label">ข้อมูลคุณแม่บ้านในระบบ</span>
        <EntityCardV2026 variant="card"
                         :avatarUrl="avatarUrl"
                         :displayName="pro.full_name"
                         idLabel="Provider ID:"
                         :idValue="pro.id"
                         :idHref="linkProfileProfessional(pro.id)" />
      </div>
      <div class="v2026-ap-system" v-if="app">
        <span class="v2026-ap-section-label">ข้อมูลผู้สมัครในระบบ</span>
        <EntityCardV2026 variant="card"
                         :avatarUrl="placeholderAvatar"
                         :displayName="app.full_name"
                         idLabel="Applicant ID:"
                         :idValue="app.id"
                         :idHref="applicantRegisterHref" />
      </div>
      <div class="v2026-ap-system" v-if="showBlocks.systemCustomer && cust"><!-- HIDDEN, see showBlocks -->
        <span class="v2026-ap-section-label">ข้อมูลลูกค้าในระบบ</span>
        <EntityCardV2026 variant="card"
                         :avatarUrl="customerAvatar"
                         :displayName="cust.full_name"
                         idLabel="User ID:"
                         :idValue="cust.id"
                         :idHref="linkProfileUser(cust.id)" />
      </div>

      <PanelStatusRowsV2026 v-if="showBlocks.statusRows" :rows="statusRows" /><!-- HIDDEN, see showBlocks -->

      <ServiceBadgesV2026 v-if="showBlocks.serviceBadges" :professional="pro" /><!-- HIDDEN, see showBlocks -->
      <ChipRowV2026 v-if="showBlocks.inconveniencePets"
                    label="ไม่สะดวกรับงานบ้านที่มีสัตว์เลี้ยง" :items="inconveniencePets" /><!-- HIDDEN, see showBlocks -->
      <ChipRowV2026 v-if="showBlocks.partners" label="งาน Partner" :items="partners" /><!-- HIDDEN, see showBlocks -->

      <LimitationSectionV2026 :professionalId="proId"
                              :value="limitationValue"
                              :audit="limitationAudit"
                              :adminId="admin && admin.id"
                              :adminName="(admin && admin.name) || ''"
                              @saved="onLimitationSaved" />
    </div><!-- /TAB 1 -->

    <div class="v2026-ap-tabpane v2026-ap-notes" v-if="activeTab === 2">
      <SystemNotesV2026 ref="secSystemNotes" v-if="noteContext" :type="noteContext.type"
                        :entityId="noteContext.id" :admin="admin" />
      <ChatNoteV2026 ref="secChatNote" v-if="conv" :type="1" :customer="conv" :conversationId="conversationId" />
    </div><!-- /TAB 2 -->

    <div class="v2026-ap-tabpane v2026-ap-bookings" v-if="activeTab === 3 && hasPro">
      <ScheduleTabV2026 :type="1"
        :professionals="professionals" :selectedMaid="selectedMaid" :scheduleMonth="scheduleMonth"
        :ordersByDayMap="ordersByDayMap" :selectedScheduleDay="selectedScheduleDay"
        :scheduleLoading="scheduleLoading" :selectedDayOrders="selectedDayOrders"
        :latestOrder="latestOrder" :useCalendarComponent="useCalendarComponent"
        :icons="icons" :weekdays="weekdays" :calendarCells="calendarCells"
        :thaiMonthLabel="thaiMonthLabel"
        @search="onSearchMaid" @select-maid="onSelectMaid" @month-change="onCalMonthChange"
        @select-day="onCalSelectDay" @create="createBooking"
        @prev-month="prevMonth" @next-month="nextMonth" @select-cell="selectScheduleDay" />
    </div><!-- /TAB 3 -->

    </div><!-- /v2026-ap-scroll -->

    <BaseToast :open="toast.open" :variant="toast.variant" :title="toast.title" :message="toast.message"
               @close="toast.open = false" />
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import PanelCollapseBarV2026 from './PanelCollapseBarV2026.vue'
import PanelTabBarV2026 from './PanelTabBarV2026.vue'
import PanelSubTabBarV2026 from './PanelSubTabBarV2026.vue'
import panelSubTabs2026 from './panelSubTabs2026'
import PanelHeaderV2026 from './PanelHeaderV2026.vue'
import ImportantMessageV2026 from './ImportantMessageV2026.vue'
import UserInfoCardV2026 from './UserInfoCardV2026.vue'
import TagsSectionV2026 from './TagsSectionV2026.vue'
import EntityCardV2026 from './EntityCardV2026.vue'
import PanelStatusRowsV2026 from './PanelStatusRowsV2026.vue'
import ServiceBadgesV2026 from './ServiceBadgesV2026.vue'
import ChipRowV2026 from './ChipRowV2026.vue'
import LimitationSectionV2026 from './LimitationSectionV2026.vue'
import SystemNotesV2026 from './SystemNotesV2026.vue'
import ChatNoteV2026 from './ChatNoteV2026.vue'
import ScheduleTabV2026 from './ScheduleTabV2026.vue'
import BaseToast from './BaseToast.vue'
import { resolveStatusIcons } from '@/components/coversation/statusIconCatalog'

const APPLICANT_REGISTER_BASE = 'https://admin-test.beneat.co/report/professional-register'
const TECHNICIAN_REGISTER_BASE = 'https://admin-test.beneat.co/report/technician-register'

export default {
  name: 'applicant-panel-v2026',
  mixins: [panelSubTabs2026],
  components: {
    PanelCollapseBarV2026,
    PanelTabBarV2026,
    PanelSubTabBarV2026,
    PanelHeaderV2026,
    ImportantMessageV2026,
    UserInfoCardV2026,
    TagsSectionV2026,
    EntityCardV2026,
    PanelStatusRowsV2026,
    ServiceBadgesV2026,
    ChipRowV2026,
    LimitationSectionV2026,
    SystemNotesV2026,
    ChatNoteV2026,
    ScheduleTabV2026,
    BaseToast
  },
  props: {
    selectedConversation: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      toast: { open: false, variant: 'success', title: '', message: '' },
      activeTab: 1,
      subTabScrollRef: 'subTabScroll',
      // Tab 2 only: a tab with no entry gets no strip and no spy work.
      subTabs: {
        2: [
          { key: 'sysnote', label: 'โน้ตในระบบ', refs: ['secSystemNotes'] },
          { key: 'chatnote', label: 'โน้ตแชท', refs: ['secChatNote'] }
        ]
      },
      tabLabels: {
        tab1: 'ข้อมูลผู้สมัคร',
        tab2: 'โน้ต',
        tab3: 'ตารางงาน',
        tab4: 'ผู้ช่วย AI'
      },
      // Tabs 3+4 render but never activate on this rail: its only job is turning an applicant
      // into a maid. Greyed rather than hidden so the chrome matches the other panels. Their
      // panes and wiring are kept — re-enabling is removing an entry from this array.
      disabledTabs: [3, 4],
      // Hidden, NOT deleted — the user wants the markup kept for later. Flip a key to true and
      // the block returns; every computed and helper behind all six is still wired.
      showBlocks: {
        systemProfessional: false,
        systemCustomer: false,
        statusRows: false,
        serviceBadges: false,
        inconveniencePets: false,
        partners: false
      },
      icons: {
        chevron: require('@/assets/icons2026/arrow-right.svg'),
        line: require('@/assets/icons2026/line-color.svg'),
        facebook: require('@/assets/icons2026/facebook-color.svg'),
        externalLink: require('@/assets/icons2026/external-link.svg'),
        chevronLeft: require('@/assets/icons2026/chevron-left.svg'),
        chevronRight: require('@/assets/icons2026/chevron-right.svg'),
        clock: require('@/assets/icons2026/clock.svg'),
        bClock: require('@/assets/icons2026/b-time.svg'),
        calendar: require('@/assets/icons2026/calendar.svg'),
        bCalendar: require('@/assets/icons2026/b-calendar.svg'),
        bLocation: require('@/assets/icons2026/b-location.svg'),
        bMapLocation: require('@/assets/icons2026/b-maps-location.svg'),
        createBooking: require('@/assets/icons2026/create-booking.svg')
      },
      weekdays: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
      thaiMonths: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      scheduleMonth: moment().startOf('month'),
      useCalendarComponent: true,
      selectedMaid: null,
      maidOrders: [],
      scheduleLoading: false,
      selectedScheduleDay: null,
      placeholderAvatar: 'https://beneat.co/static/img/unknown.png',
      limitationOverride: undefined,
      limitationAuditOverride: null
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('tag', ['tags']),
    ...mapState('professional', ['professionals']),

    pro () {
      return (this.customer && this.customer.professional) ? this.customer.professional : null
    },
    app () {
      return (this.customer && this.customer.applicant) ? this.customer.applicant : null
    },
    cust () {
      return (this.customer && this.customer.customer) ? this.customer.customer : null
    },
    conv () {
      return (this.selectedConversation && this.selectedConversation.customer)
        ? this.selectedConversation.customer : null
    },
    // Guarded on the id so a missing one yields null, never ".../user/undefined".
    headerUserHref () {
      const id = this.conv && this.conv.beneat_user_id
      return id ? this.linkProfileUser(id) : null
    },
    conversationId () {
      return this.selectedConversation ? this.selectedConversation.id : null
    },
    hasPro () {
      return this.pro !== null
    },
    // Is there a tb_customer row to write to at all? Every chat-contact edit gates on this.
    hasConv () {
      return this.conv !== null
    },
    proId () {
      return this.pro ? this.pro.id : null
    },

    // System notes keep the LEGACY precedence customer > professional > applicant, unlike the
    // display blocks. Deliberate: display precedence reverts for free, but writing notes to a
    // different record splits the history across tables and needs a migration to undo.
    noteContext () {
      if (this.cust) return { type: 0, id: this.cust.id }
      if (this.pro) return { type: 1, id: this.pro.id }
      if (this.app) return { type: 2, id: this.app.id }
      return null // no entity → the whole โน้ตในระบบ block is not rendered
    },

    avatarUrl () {
      const pic = this.pro && this.pro.picture
      if (!pic) return this.placeholderAvatar
      // professional.picture is a bare S3 filename; guard an already-absolute URL.
      if (/^(https?:)?\/\//.test(pic)) return pic
      return `https://beneat.s3-ap-southeast-1.amazonaws.com/professionals/${pic}`
    },
    customerAvatar () {
      return (this.cust && this.cust.picture) ? this.cust.picture : this.placeholderAvatar
    },
    // '' rather than '-': the empty string is what triggers the ＋เพิ่มชื่อ pill.
    // Same icons the chat card puts before the name.
    headerStatusIcons () {
      const ids = this.selectedConversation && this.selectedConversation.status_icons
      return resolveStatusIcons(Array.isArray(ids) ? ids : [])
    },
    headerName () {
      const n = this.conv && this.conv.name
      if (n && String(n).trim()) return n
      if (this.pro && this.pro.full_name) return this.pro.full_name
      if (this.app && this.app.full_name) return this.app.full_name
      return ''
    },
    roleLabel () {
      return (this.app && this.app.is_techician_register) ? 'ผู้สมัคร (คุณช่าง)' : 'ผู้สมัคร'
    },
    regionLabel () {
      return (this.pro && this.pro.province && this.nonEmpty(this.pro.province.name_th))
        ? this.pro.province.name_th : null
    },
    channelBadge () {
      const type = this.selectedConversation ? this.selectedConversation.type : null
      switch (type) {
        case 'LineAtConversation':
        case 'LineProfessionalConversation':
          return { icon: this.icons.line, alt: 'LINE' }
        case 'PublicConversation':
          return { icon: this.icons.facebook, alt: 'Facebook' }
        default:
          return null
      }
    },

    entityIdValue () {
      if (this.pro) return this.pro.id
      return this.app ? this.app.id : null
    },
    entityIdHref () {
      return this.pro ? null : this.applicantRegisterHref
    },
    phone () {
      if (this.pro && this.pro.phone) return this.pro.phone
      if (this.conv && this.conv.phone) return this.conv.phone
      return (this.app && this.app.tel) ? this.app.tel : null
    },
    email () {
      if (this.pro && this.pro.email) return this.pro.email
      if (this.conv && this.conv.email) return this.conv.email
      return (this.app && this.app.email) ? this.app.email : null
    },
    hasContactRow () {
      return this.entityIdValue != null || this.nonEmpty(this.phone) || this.nonEmpty(this.email)
    },
    applicantRegisterHref () {
      const a = this.app
      if (!a) return null
      const keyword = this.nonEmpty(a.id_card_number)
        ? a.id_card_number : (this.nonEmpty(a.tel) ? a.tel : null)
      if (!keyword) return null
      const base = a.is_techician_register ? TECHNICIAN_REGISTER_BASE : APPLICANT_REGISTER_BASE
      return `${base}?keyword=${keyword}`
    },

    groupBadgeHtml () {
      if (!this.pro) return ''
      return this.$options.filters.professionalGroupId(this.pro.professional_group_id, this.pro.status)
    },
    isOnline () {
      return !!(this.pro && Number(this.pro.active) === 1)
    },
    statusRows () {
      const rows = []
      if (!this.pro) return rows
      if (this.nonEmpty(this.groupBadgeHtml)) {
        rows.push({ key: 'group', label: 'Group', html: this.groupBadgeHtml })
      }
      // `0` is a VALID active value (→ ออฟไลน์); only a missing field omits the row.
      if (this.pro.active != null) {
        rows.push({
          key: 'status',
          label: 'สถานะ',
          text: this.isOnline ? 'ออนไลน์' : 'ออฟไลน์',
          dot: this.isOnline ? 'online' : 'offline'
        })
      }
      return rows
    },

    inconveniencePets () {
      return (this.pro && Array.isArray(this.pro.inconvenience_pets)) ? this.pro.inconvenience_pets : []
    },
    partners () {
      return (this.pro && Array.isArray(this.pro.partners)) ? this.pro.partners : []
    },

    limitationValue () {
      if (this.limitationOverride !== undefined) return this.limitationOverride
      return this.pro ? this.pro.limitation : null
    },
    limitationAudit () {
      if (this.limitationAuditOverride) return this.limitationAuditOverride
      const p = this.pro
      if (p && p.limitation_update_by_admin) {
        return { limitation_updated_at: p.limitation_updated_at, name: p.limitation_update_by_admin.name }
      }
      return null
    },

    latestOrder () {
      return (this.pro && this.pro.latest_order) ? this.pro.latest_order : null
    },
    thaiMonthLabel () {
      return `${this.thaiMonths[this.scheduleMonth.month()]} ${this.scheduleMonth.year()}`
    },
    ordersByDayMap () {
      const map = {}
      this.maidOrders.forEach(o => {
        if (!o.cleaning_date) return
        const key = moment(o.cleaning_date).format('YYYY-MM-DD')
        if (!map[key]) map[key] = []
        map[key].push(o)
      })
      return map
    },
    calendarCells () {
      const start = this.scheduleMonth.clone().startOf('month')
      const daysInMonth = start.daysInMonth()
      const leading = start.day()
      const map = this.ordersByDayMap
      const cells = []
      for (let i = 0; i < leading; i++) {
        cells.push({ blank: true, key: 'blank-' + i })
      }
      for (let d = 1; d <= daysInMonth; d++) {
        const dateStr = start.clone().date(d).format('YYYY-MM-DD')
        cells.push({ blank: false, key: dateStr, day: d, dateStr, count: (map[dateStr] || []).length })
      }
      return cells
    },
    selectedDayOrders () {
      if (!this.selectedScheduleDay) return []
      return this.ordersByDayMap[this.selectedScheduleDay] || []
    }
  },
  watch: {
    proId: {
      handler (id, oldId) {
        if (id) {
          this.seedMaidFromPro()
        }
        if (id !== oldId) {
          this.limitationOverride = undefined
          this.limitationAuditOverride = null
        }
      },
      immediate: true
    },
    // Unreachable while tab 3 is disabled, but it is the guard tab 3 needs the moment it returns.
    hasPro (v) {
      if (!v && this.activeTab === 3) this.activeTab = 1
    }
  },
  methods: {
    ...mapActions('professional', ['searchProfessionals']),
    nonEmpty (v) {
      return v != null && String(v).trim() !== ''
    },
    // Second lock: the tab bar already refuses a disabled tab, so activeTab cannot reach 3 or 4.
    setTab (n) {
      if (this.disabledTabs.indexOf(n) !== -1) return
      this.activeTab = n
    },
    linkProfileProfessional (id) {
      return id != null ? `https://admin-test.beneat.co/professional/${id}/profile` : null
    },
    linkProfileUser (id) {
      return id != null ? `https://admin-test.beneat.co/user/${id}` : null
    },
    showToast (variant, title, message) {
      this.toast = { open: true, variant, title, message }
    },
    // Only ever OVERWRITE existing keys — a key absent from the payload is not reactive in Vue 2.
    onLimitationSaved (payload) {
      if (!payload) return
      this.limitationOverride = payload.value
      this.limitationAuditOverride = payload.audit
      if (this.pro) {
        this.pro.limitation = payload.value
        if (payload.audit) this.pro.limitation_updated_at = payload.audit.limitation_updated_at
      }
    },
    seedMaidFromPro () {
      if (this.pro && this.pro.id) {
        this.selectedMaid = { id: this.pro.id, full_name: this.pro.full_name }
        this.selectedScheduleDay = null
        this.maidOrders = []
        this.fetchSchedule()
      }
    },
    async onSearchMaid (search, loading) {
      if (!search || !search.trim()) return
      loading(true)
      try {
        await this.searchProfessionals(search)
      } finally {
        loading(false)
      }
    },
    onSelectMaid (maid) {
      this.selectedMaid = maid
      this.selectedScheduleDay = null
      this.maidOrders = []
      if (maid) this.fetchSchedule()
    },
    async fetchSchedule () {
      if (!this.selectedMaid) return
      this.scheduleLoading = true
      try {
        const month = this.scheduleMonth.format('YYYY-MM')
        const { data } = await axios.get(`/beneat/professionals/${this.selectedMaid.id}/orders`, { params: { month } })
        this.maidOrders = (data && Array.isArray(data.data)) ? data.data : []
      } catch (e) {
        this.maidOrders = []
      } finally {
        this.scheduleLoading = false
      }
    },
    prevMonth () {
      this.scheduleMonth = this.scheduleMonth.clone().subtract(1, 'month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    nextMonth () {
      this.scheduleMonth = this.scheduleMonth.clone().add(1, 'month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    selectScheduleDay (cell) {
      this.selectedScheduleDay = cell.dateStr
    },
    onCalMonthChange (ym) {
      this.scheduleMonth = moment(ym, 'YYYY-MM').startOf('month')
      this.selectedScheduleDay = null
      this.fetchSchedule()
    },
    onCalSelectDay (dateStr) {
      this.selectedScheduleDay = dateStr
    },
    createBooking () {
      const params = { auto_fill: 1 }
      if (this.conv && this.conv.id) params.user_id = this.conv.id
      if (this.selectedMaid) params.selected_professional_id = this.selectedMaid.id
      if (this.selectedScheduleDay) params.service_date = this.selectedScheduleDay
      const qs = new URLSearchParams(params).toString()
      const url = `https://admin-test.beneat.co/order/create-multiple?${qs}`
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.v2026-applicant-panel {
  --v2026-color-main: #31C1D7;
  --v2026-color-main-soft: #31C1D714;
  --v2026-color-icon-idle: #66696C;
  --v2026-link: #007bff;
  --v2026-surface: #ffffff;
  --v2026-surface-sunken: #F8FAFC;
  --v2026-surface-hover: #e9ecf1;
  --v2026-border: #e4e7ec;
  --v2026-text: #101828;
  --v2026-text-secondary: #667085;
  --v2026-text-muted: #98a2b3;
  --v2026-icon: #475467;
  --v2026-r-card: 12px;
  --v2026-r-box: 14px;
  --v2026-r-tab: 10px;
  --v2026-sp-1: 4px;
  --v2026-sp-2: 8px;
  --v2026-sp-3: 12px;
  --v2026-sp-4: 16px;
  --v2026-sp-5: 20px;
  --v2026-sp-6: 24px;
  --v2026-fs-section: 13px;
  --v2026-fs-body: 14px;
  --v2026-fs-meta: 12px;
  --v2026-fs-name: 16px;

  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
  height: 100%;
  overflow: hidden;
  background: var(--v2026-surface);
  padding: 0;
}

.v2026-ap-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: var(--v2026-sp-6);
}

.v2026-ap-tabpane {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-4);
}

.v2026-ap-notes {
  padding: var(--v2026-sp-4) var(--v2026-sp-4) 0;
}

.v2026-ap-bookings {
  padding: var(--v2026-sp-4) var(--v2026-sp-4) 0;
  gap: var(--v2026-sp-3);
}

.v2026-ap-system {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  padding: 0 var(--v2026-sp-4);
}
.v2026-ap-section-label {
  font-size: var(--v2026-fs-section);
  font-weight: 600;
  color: var(--v2026-text-secondary);
}
</style>
